import { render, staticRenderFns } from "./ShippingList.vue?vue&type=template&id=0630b083&"
import script from "./ShippingList.vue?vue&type=script&lang=js&"
export * from "./ShippingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports